import React from 'react';
import II18 from '../translate/II18';

import { Icon, Link, List, ListItem, Page } from 'framework7-react';

import PropTypes from 'prop-types';
import OpenMainInfoLink from '../common/OpenMainInfoLink';

class DesktopFullPage extends React.Component {
  constructor(props) {
    super(props);
    this.popup = null;
  }

  render() {
    return (
      <Page id={this.props.popUpId} className={this.props.sheetClassName}>
        <div className={'desktop-fullpopup'}>
          {!this.props.hideHeader && (
            <div className={'viewer-top'}>
              {!this.props.disableBack && (
                <Link
                  iconMaterial={'arrow_back'}
                  iconColor={'white'}
                  iconSize={24}
                  onClick={this.props.goBack}
                  style={{ margin: '0 20px' }}
                  tooltip={II18.get('title_back')}
                />
              )}
              <h2>{this.props.documentName}</h2>
              <OpenMainInfoLink className={'viewer-top-info'}>
                <label className={'screenreader'}>Information</label>
                <Icon size="25" icon="fas fa-info-circle" color="white" />
              </OpenMainInfoLink>
            </div>
          )}
          <div className={'viewer-container'}>
            <div
              className={'tinny-scrollbar pages-side'}
              id={this.props.pageSideId}
            >
              {this.props.pageContent}
              {this.props.additionalPageContent}
            </div>

            <div
              className={
                'buttons-side tinny-scrollbar ' +
                (this.props.hideButtonsSide ? 'hide' : '')
              }
            >
              <List inset>
                {!this.props.hideButtonsSide &&
                  this.props.actionsList &&
                  this.props.actionsList.map(
                    action =>
                      action.visible && (
                        <ListItem
                          id={action.id}
                          className={action.className}
                          key={action.id}
                          noChevron
                          link="#"
                          title={action.title}
                          onClick={action.onClick}
                        >
                          <Icon
                            material={action.materialIcon}
                            icon={action.icon}
                            slot={'before-title'}
                          />
                        </ListItem>
                      )
                  )}
              </List>
              {this.props.additionalSideContent}
            </div>
          </div>
        </div>
      </Page>
    );
  }
}

DesktopFullPage.propTypes = {
  hideHeader: PropTypes.bool,
  hideButtonsSide: PropTypes.bool,
  sheetClassName: PropTypes.string,
  documentName: PropTypes.string.isRequired,
  additionalSideContent: PropTypes.object,
  additionalPageContent: PropTypes.any,
  pageContent: PropTypes.object.isRequired,
  actionsList: PropTypes.array,
  onClose: PropTypes.func,
  goBack: PropTypes.func.isRequired,
  popUpId: PropTypes.string.isRequired,
  pageSideId: PropTypes.string.isRequired,
  disableBack: PropTypes.bool
};

export default DesktopFullPage;
